import React, { FC, useEffect } from 'react'
import UserForm from './UserForm'
import avatar from '../../../assets/images/user3.png'
import { IUsers } from '../../../models/IUsers'
import { $public } from '../../../http'
import Avatar from '../../../components/UI/avatar/Avatar'
import NonPhoto from '../../../assets/images/non-photo.png'
interface IUser {
  value: string,
  data: IUsers
}

const User: FC<IUser> = ({ data }) => {
  return (
    <section className='section' data-value='info'>
      <div className="section-title">User information</div>
      {data !== undefined && (
        <div className="card">
          <div className="avatar-container">
            {data.photo && (
              <img src={$public(data?.photo)} alt="avatar" style={{width:"100%", height:"100%", borderRadius:"50%"}}/>
            )}
            {!data.photo && (
              // <Avatar name={data.name} size="reg" />
              <img src={NonPhoto} alt="avatar is here"  />
            )}
          </div>
          <UserForm data={data} />
        </div>
      )}
    </section>
  )
}

export default User